import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Button } from 'components'
import styles from './index.module.css'

const CarRepair = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1">
				<div className="padding flex-justify_between align_center">
					<h3>수리∙정비 이력</h3>
					<span className={styles["title-guide"]}>2017.01.01 ~ 2021.01.01</span>
				</div>
				<ul className="step-area list-bg mt_20">
					<li>
						<div>
							<span className="date">2021.10</span>
							<div className="txt-area">
								<p>미션오일 교환, 엔진오일 교환</p>
								<span className="mt_5">주행거리 120,000 km</span>
							</div>
							<div className="txt-area">
								<p>타이어 교체</p>
								<span className="mt_5">주행거리 70,000 km</span>
							</div>
							<span className="circle" />
						</div>
					</li>
					<li>
						<div>
							<span className="date">2021.08</span>
							<div className="txt-area">
								<p>후미등 교체</p>
								<span className="mt_5">주행거리 120,000 km</span>
							</div>
							<span className="circle" />
						</div>
					</li>
					<li>
						<div>
							<span className="date">2021.08</span>
							<div className="txt-area">
								<p>후미등 교체</p>
								<span className="mt_5">주행거리 120,000 km</span>
							</div>
							<span className="circle" />
						</div>
					</li>
				</ul>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big btn-more">+ 더보기</Button>
			</div>
		</div>
	)
}

export default CarRepair